
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import styled from "styled-components"
import { showModal } from "../../../features/modal/modalSlice"
import Btn from "../../shared/button/Btn"
import InputCityTown from "../../shared/input/new/InputCityTown"
import InputText from "../../shared/input/new/InputText"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"
import InputNewAracTypeSelect from "../../shared/input/new/InputNewAracTypeSelect"
import InputCaseTypeSelect from "../../shared/input/new/InputCaseTypeSelect"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputSelect from "../../shared/input/new/InputSelect"
import { toast } from "react-toastify"
import InputTruck from "../../shared/input/relative/InputTruck"
import InputTrailer from "../../shared/input/relative/InputTrailer"
import InputDate from "../../shared/input/new/InputDate"
import { addQuickLoad } from "../../../features/addLoad/addLoadSlice"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 600px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 30px 20px 30px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: ${({theme}) => theme.mainTextColor};

     
        .content{
            display: flex;
            flex-direction: column;
            align-items: center;
            color: ${({theme}) => theme.mainTextColor};
            width: 100%;


            h2{
                font-size: var(--font-size-xl);
                font-weight: var(--font-weight-xl);
                margin-bottom: 25px;
            }

            .input-container{
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 20px;
                height: 500px;
                max-height: 500px;
                overflow: auto;
                width: 80%;
                overflow: auto;
                padding: 20px 0;

                
        &::-webkit-scrollbar {
            width: 0;
            width: 5px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.scrollThumbColor};
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
           

                .input-grp{
                    width: 90%;

                    .error{
                        font-size: 12px;
                        color: var(--color-main);
                        font-weight: var(--font-weight-lg);
                    }
                }
            }


            .btn-container{
                display: flex;
                justify-content: center;
                margin-top: 30px;
                gap: 20px;
                border-top: 1px solid ${({theme}) => theme.mainBorderColor};
            }
        }
         
    }
`

const FastLoadModal = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)

    const [ from, setFrom ] = useState(null)
    const [ to, setTo ] = useState(null)
    const [ loadType, setLoadType ] = useState("")
    const [ cost, setCost ] = useState("")
    const [ truckType, setTruckType ] = useState(null)
    const [ trailerType, setTrailerType ] = useState(null)
    const [ loadDate, setLoadDate ] = useState("")
    const [ tonnage, setTonnage ] = useState("")
    const [ officialName, setOfficialName ] = useState("")
    const [ officialPhoneNumber, setOfficialPhoneNumber ] = useState("")
    const [ fromCompanyName, setFromCompanyName ] = useState("")
    const [ toCompanyName, setToCompanyName ] = useState("")
    const [ companyLoadNumber, setCompanyLoadNumber ] = useState("")
    const [ customsPlace, setCustomsPlace ] = useState("")
    const [ vesselDate, setVesselDate ] = useState("")
    const [ isFreeZone, setIsFreeZone ] = useState(false)


    const { lockScroll, unlockScroll } = useScrollLock();

    const [isSubmit, setIsSubmit] = useState(false)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()
        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    useEffect(() => {
        setTrailerType(null)
    },[truckType])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleTonnageChange = (e) => {
        // console.log(e);

        if(parseInt(e?.target?.value?.replace(/[^0-9 ]/g, '')) < 31 || e?.target?.value === ""){
            setTonnage(e?.target?.value?.replace(/[^0-9]/g, ''))
        }
        else{
            setTonnage(30)
            toast.warning(`Tonaj 30'dan fazla olamaz.`, {
                position: "bottom-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }

    }





    const handleDateChange = (e) => {
          const today = new Date().toISOString().split("T")[0];
          if(e.target.value < today){
            return
          }
          setLoadDate(e.target.value)
    }


    
    const handleSubmit = () => {

        setIsSubmit(true)

        const trailerIsValid = truckType?.id === 8 || Boolean(trailerType?.id)
        if(from && to && truckType?.id && trailerIsValid && tonnage && loadDate && officialPhoneNumber[2] === "5" && officialPhoneNumber.slice(2).length === 10){
            const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage
        const body = {
            loadType: loadType,
            cost: cost ? parseInt(cost) : 0,
            companyLoadNumber,
            customsPlace,
            vesselDate: vesselDate || null,
            isFreeZone,
            truckTypeId: truckType.id,
            trailerTypeId: trailerType?.id ?? null,
            tonnage: parseInt(tonnage),
            phoneNumber:  JSON.parse(storage.getItem("cPhoneNumber"))?.replace(/^90/, ""),
            routePoints: [
                {
                    city: from.city,
                    town: from.town,
                    companyName: fromCompanyName,
                    routePointPersonName: officialName,
                    routePointPersonPhoneNumber: officialPhoneNumber.slice(2),
                    lat: from.lat,
                    lng: from.lng,
                    loadDate: new Date(loadDate).toISOString()
                },
                {
                    city: to.city,
                    town: to.town,
                    companyName: toCompanyName,
                    routePointPersonName: officialName,
                    routePointPersonPhoneNumber: officialPhoneNumber.slice(2),
                    lat: to.lat,
                    lng: to.lng,
                    loadDate: new Date(loadDate).toISOString()
                }
            ] 
        }


        dispatch(addQuickLoad(body))
    }

    }

  return (
    <Container onClick={(e) => e.stopPropagation()}>
        <div className="modal" onClick={() => dispatch(handleActiveSelect())}>
            <div className="content">
                <h2>Hızlı Yük Girin</h2>
                <div className="input-container">

                <div className="input-grp">
                    <InputCityTown data={from?.location} setData={setFrom} labelText={"Nereden*"} inputWidth={"100%"} name={"from"}/>
                    {(isSubmit && (!from?.city || !from?.town)) &&
                        <span className="error">Nereden Bilgisini Giriniz.</span>
                    }
                </div>

                <div className="input-grp">
                    <InputText data={fromCompanyName} setData={(e) => setFromCompanyName(e.target.value)} labelText="Yükleme Firma Adı" inputWidth="100%" name="fromCompanyName"/>
                </div>

                <div className="input-grp">
                    <InputCityTown data={to?.location} setData={setTo} labelText={"Nereye*"} inputWidth={"100%"} name={"to"}/>
                    {(isSubmit && (!to?.city || !to?.town)) &&
                        <span className="error">Nereye Bilgisini Giriniz.</span>
                    }
                </div>

                <div className="input-grp">
                    <InputText data={toCompanyName} setData={(e) => setToCompanyName(e.target.value)} labelText="Boşaltma Firma Adı" inputWidth="100%" name="toCompanyName"/>
                </div>

                <div className="input-grp">
                    <InputTruck labelText={"Araç Türü*"} data={truckType} setData={setTruckType} name={"truckType"} inputWidth={"100%"} setTrailerData={setTrailerType} isRequired={false}/>
                    {(isSubmit && !truckType?.id) &&
                        <span className="error">Araç Türünü Giriniz.</span>
                    }
                </div>

                {
                    (truckType?.id && truckType?.id !== 8) &&
                    <div className="input-grp">
                        <InputTrailer labelText={"Kasa Tipi*"} data={trailerType} setData={setTrailerType} initialOptions={truckType?.trailerTypesModel?.$values} truckType={truckType} name={"caseType"} inputWidth={"100%"} isRequired={false}/>
                        {(isSubmit && !trailerType?.id) &&
                            <span className="error">Kasa Türünü Giriniz.</span>
                        }
                    </div>
                }

                <div className="input-grp">
                    <InputText data={loadType} setData={(e) => setLoadType(e.target.value)} labelText="Yük Türü" inputWidth={"100%"} name={"loadType"}/>
                </div>

                <div className="input-grp">
                    <InputText data={tonnage} setData={handleTonnageChange} labelText="Tonaj*" inputWidth={"100%"} name={"tonnage"}/>
                    {(isSubmit && !tonnage) &&
                        <span className="error">Tonaj Bilgisini Giriniz.</span>
                    }
                </div>
                
                <div className="input-grp">
                    <InputDate data={loadDate} setData={(e) => handleDateChange(e)} min={new Date().toISOString().split('T')[0]} labelText={"Yükleme Tarihi*"} inputWidth={"100%"} name={"loadDate"}/>
                    {(isSubmit && !loadDate) &&
                        <span className="error">Yükleme Tarihini Giriniz.</span>
                    }
                </div>

                <div className="input-grp">
                    <InputText data={cost} setData={(e) => setCost(e?.target?.value?.replace(/[^0-9]/g, ''))} labelText="Nakliye Bedeli (KDV Hariç)" inputWidth={"100%"} name={"cost"}/>
                </div>

                <div className="input-grp">
                    <InputText data={companyLoadNumber} setData={(e) => setCompanyLoadNumber(e.target.value)} labelText="Booking No / Firma Yük No" inputWidth="100%" name="companyLoadNumber"/>
                </div>

                <div className="input-grp">
                    <InputText data={customsPlace} setData={(e) => setCustomsPlace(e.target.value)} labelText="Gümrük Yeri" inputWidth="100%" name="customsPlace"/>
                </div>

                <div className="input-grp">
                    <InputDate data={vesselDate} setData={(e) => setVesselDate(e.target.value)} labelText="Gemi Tarihi" inputWidth="100%" name="vesselDate"/>
                </div>

                <label className="input-grp" style={{justifyContent: "flex-start", cursor: "pointer"}}>
                    <input type="checkbox" checked={isFreeZone} onChange={(e) => setIsFreeZone(e.target.checked)} />
                    <span>Serbest Bölge</span>
                </label>

                <div className="input-grp">
                    <InputText data={officialName} setData={(e) => setOfficialName(e.target.value)} labelText="Yetkili Ad Soyad*" inputWidth={"100%"} name={"officialName"}/>
                    {(isSubmit && !officialName) &&
                        <span className="error">Yetkili Ad Soyad Giriniz.</span>
                    }
                </div>

                <div className="input-grp">
                    <InputPhoneFormat data={officialPhoneNumber} setData={setOfficialPhoneNumber} labelText="Yetkili Telefon Numarası*" inputWidth={"100%"} name={"officialPhoneNumber"}/>
                    {(isSubmit && !officialPhoneNumber) &&
                        <span className="error">Yetkili Telefon Numarası Giriniz.</span>
                    }
                    {
                        (isSubmit && ((officialPhoneNumber.length > 2 && officialPhoneNumber[2] !== "5") || officialPhoneNumber.length !== 12)) &&
                        <span className="error">Telefon Numarası 5 ile Başlamak ve 10 Haneli Olmak Zorundadır.</span>
                    }
                </div>

                </div>
                <div className="btn-container">
                    <Btn bgColor="#E85446" color="#fff" handleClick={handleSubmit} width={"220px"}>Kaydet</Btn>
                    <Btn bgColor="transparent" color="#E85446" handleClick={()=> dispatch(showModal(null))} width={"220px"}>Çıkış</Btn>
                </div>
            </div>
        </div>
    </Container>
  )
}

export default FastLoadModal
